<template>
  <svg width="22"
       height="18"
       viewBox="0 0 22 18"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M3.01953 17.8809H18.9629C20.8613 17.8809 21.8633 16.8965 21.8633 15.0156V5.78711C21.8633 3.90625 20.8613 2.92188 18.9629 2.92188H16.625C15.9395 2.92188 15.7197 2.80762 15.2891 2.35938L14.5947 1.6123C14.1377 1.12891 13.6719 0.891602 12.7754 0.891602H9.16309C8.2666 0.891602 7.80078 1.12891 7.34375 1.6123L6.64941 2.35938C6.22754 2.79883 5.99902 2.92188 5.31348 2.92188H3.01953C1.12109 2.92188 0.12793 3.90625 0.12793 5.78711V15.0156C0.12793 16.8965 1.12109 17.8809 3.01953 17.8809ZM10.9912 15.1211C8.36328 15.1211 6.25391 13.0117 6.25391 10.375C6.25391 7.72949 8.36328 5.62012 10.9912 5.62012C13.6279 5.62012 15.7373 7.72949 15.7373 10.375C15.7373 13.0117 13.6279 15.1211 10.9912 15.1211ZM16.2998 7.14062C16.2998 6.5166 16.8359 5.97168 17.4775 5.97168C18.1104 5.97168 18.6465 6.5166 18.6465 7.14062C18.6465 7.79102 18.1104 8.30078 17.4775 8.30957C16.8359 8.30957 16.2998 7.7998 16.2998 7.14062ZM10.9912 13.5303C12.7402 13.5303 14.1465 12.124 14.1465 10.375C14.1465 8.61719 12.7402 7.21094 10.9912 7.21094C9.25098 7.21094 7.84473 8.61719 7.84473 10.375C7.84473 12.124 9.25977 13.5303 10.9912 13.5303Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'ImageIcon',
  props: {
    color: {
      type: String,
      default: '#8898A9'
    }
  }
}
</script>
<style>
</style>
